/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import { events } from './events/index';
import { components } from './components/index';

const PartiesEmailInfo = {
  events,
  components
};

export { PartiesEmailInfo }